import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface PageHeaderInfo {
  title?: string;
  subtitle?: string;
  icon?: string;
  badgeText?: string | number;
  badgeColor?: string;
  useCardIcon?: boolean;
  iconColor?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NavbarPortalService {
  private centerPortalSubject = new BehaviorSubject<TemplateRef<any> | null>(null);
  private leftPortalSubject = new BehaviorSubject<TemplateRef<any> | null>(null);
  private rightPortalSubject = new BehaviorSubject<TemplateRef<any> | null>(null);
  private pageHeaderSubject = new BehaviorSubject<PageHeaderInfo | null>(null);
  private hasRightActionsSubject = new BehaviorSubject<boolean>(false);

  public centerPortal$: Observable<TemplateRef<any> | null> = this.centerPortalSubject.asObservable();
  public leftPortal$: Observable<TemplateRef<any> | null> = this.leftPortalSubject.asObservable();
  public rightPortal$: Observable<TemplateRef<any> | null> = this.rightPortalSubject.asObservable();
  public pageHeader$: Observable<PageHeaderInfo | null> = this.pageHeaderSubject.asObservable();
  public hasRightPortal$: Observable<boolean> = this.hasRightActionsSubject.asObservable();

  setCenterPortal(portal: TemplateRef<any> | null): void {
    Promise.resolve().then(() => this.centerPortalSubject.next(portal));
  }

  setLeftPortal(portal: TemplateRef<any> | null): void {
    Promise.resolve().then(() => this.leftPortalSubject.next(portal));
  }

  setRightPortal(portal: TemplateRef<any> | null): void {
    Promise.resolve().then(() => this.rightPortalSubject.next(portal));
  }

  setHeaderInfo(info: PageHeaderInfo | null): void {
    Promise.resolve().then(() => this.pageHeaderSubject.next(info));
  }

  setHasRightActions(hasActions: boolean): void {
    Promise.resolve().then(() => this.hasRightActionsSubject.next(hasActions));
  }

  clearAll(): void {
    Promise.resolve().then(() => {
      this.centerPortalSubject.next(null);
      this.leftPortalSubject.next(null);
      this.rightPortalSubject.next(null);
      this.pageHeaderSubject.next(null);
      this.hasRightActionsSubject.next(false);
    });
  }
}
